import React from "react";
import { motion } from "framer-motion";
import { Trophy, Crown } from "lucide-react";
import { STAGE_LABELS } from "../lib/api";

const STAGES = ["row", "two_rows", "full"];

export function Scoreboard({ game }) {
  const total = STAGES.reduce((s, k) => s + (game.winners?.[k] ? game.prizes[k] : 0), 0);
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} data-testid="studio-scoreboard"
      className="fixed inset-0 z-30 bg-[#0B0C10]/95 backdrop-blur-md flex flex-col items-center justify-center p-8 lg:p-16">
      <div className="text-[#FF007F] text-sm lg:text-xl uppercase tracking-[0.5em] mb-3">Einde van de ronde</div>
      <h1 className="text-4xl lg:text-7xl font-black text-center" style={{ fontFamily: "Unbounded, sans-serif" }} data-testid="scoreboard-title">
        {game.title}
      </h1>
      <div className="mt-10 lg:mt-14 grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-8 w-full max-w-6xl">
        {STAGES.map((stage, i) => {
          const w = game.winners?.[stage];
          return (
            <motion.div key={stage} initial={{ y: 60, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: 0.3 + i * 0.25, type: "spring", stiffness: 160 }}
              data-testid={`scoreboard-${stage}`}
              className={`relative p-6 lg:p-8 rounded-3xl border ${stage === "full" ? "bg-[#FFD700]/10 border-[#FFD700]/50 shadow-[0_0_60px_-10px_rgba(255,215,0,0.5)]" : "bg-[#12141D] border-white/10"}`}>
              <div className="flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-slate-400">
                {stage === "full" ? <Crown className="w-4 h-4 text-[#FFD700]" /> : <Trophy className="w-4 h-4 text-[#FF007F]" />}
                {STAGE_LABELS[stage]}
              </div>
              <div className="mt-4 text-3xl lg:text-5xl font-black truncate" style={{ fontFamily: "Unbounded, sans-serif" }} data-testid={`scoreboard-${stage}-name`}>
                {w ? w.display_name : <span className="text-slate-600">—</span>}
              </div>
              <div className="mt-3 text-2xl lg:text-4xl font-black text-[#00E676]">€{game.prizes[stage]}</div>
              {!w && <div className="mt-2 text-xs text-slate-500">Geen winnaar</div>}
            </motion.div>
          );
        })}
      </div>
      <div className="mt-10 flex flex-wrap justify-center gap-8 text-slate-400 text-sm uppercase tracking-widest">
        <span>Nummers getrokken: <b className="text-slate-100">{game.drawn.length}</b>/90</span>
        <span>Uitgekeerd: <b className="text-[#FFD700]" data-testid="scoreboard-total">€{total}</b></span>
      </div>
      <div className="mt-6 text-slate-500 text-xs uppercase tracking-[0.4em]">Bedankt voor het meespelen</div>
    </motion.div>
  );
}
